import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { t } from 'utils/translates';

import { selectCounts } from 'mt-react-common/modules/main/reducers/static/states/counts/reducer';

const CompetitionsNav = props => {
  useEffect(() => {
    // eslint-disable-next-line no-undef
    $(`#panelGroupMenu_c_5`).collapse(props.isOpen ? 'show' : 'hide');
  }, [props.isOpen]);

  return (
    <div className="panel panel-default">
      <div className="panel-heading" role="tab" id="panelGroupMenu_h_5">
        <a
          className="dropdown-toggle dropdown-toggle-collapse collapsed"
          role="button"
          data-toggle="collapse"
          data-parent="#panelGroupMenu"
          href={null}
          aria-expanded="false"
          aria-controls="panelGroupMenu_c_5"
          title={t('Конкурсы')}
          onClick={props.onToggle}
        >
          <i className="fa fa-trophy fa-lg fa-fw" aria-hidden="true" />{' '}
          {t('Конкурсы')}
        </a>
      </div>
      <div
        id="panelGroupMenu_c_5"
        className={'panel-collapse collapse'}
        role="tabpanel"
        aria-labelledby="panelGroupMenu_h_5"
      >
        <div className="list-group">
          <NavLink
            to="/competitions/new"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="badge">{props.counts.started_contests.count}</span>{' '}
            <span className="list-group-item-val">{t('Новые')}</span>
          </NavLink>
          <NavLink
            to="/competitions/my-participation"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="badge">{props.counts.me_contests.count}</span>{' '}
            <span className="list-group-item-val">{t('Я участвую')}</span>
          </NavLink>
          <NavLink
            to="/competitions/finished"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="badge">
              {props.counts.completed_contests.count}
            </span>{' '}
            <span className="list-group-item-val">{t('Законченные')}</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

CompetitionsNav.defaultProps = {
  isOpen: false,
  onToggle: () => {}
};

CompetitionsNav.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  // CONNECT STATES
  counts: PropTypes.shape({
    started_contests: PropTypes.shape({
      count: PropTypes.number.isRequired
    }).isRequired,
    me_contests: PropTypes.shape({
      count: PropTypes.number.isRequired
    }).isRequired,
    completed_contests: PropTypes.shape({
      count: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  counts: selectCounts(state)
});

export default withRouter(connect(mapStateToProps)(CompetitionsNav));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Sidebar/Navs/CompetitionsNav.js